import { useQuery } from '@tanstack/react-query'
import { useSearch } from '@tanstack/react-router'
import { getApiV1WeddingsByWeddingIdSettingsOptions } from '@wedding-tech/api-client/tanstack'

import { env } from '@/config'

import { extractEventId } from './context'

export function useLiffId(): {
  liffId: string | null
  isLoading: boolean
} {
  const search = useSearch({ from: '__root__', shouldThrow: false })
  const eventId = extractEventId()

  const { data, isLoading } = useQuery({
    ...getApiV1WeddingsByWeddingIdSettingsOptions({
      path: { weddingId: eventId },
    }),
    enabled: Boolean(eventId),
    staleTime: 5 * 60_000,
  })

  const eventLiffId = (data?.data as Record<string, unknown> | undefined)
    ?.liffId as string | undefined

  const resolvedLiffId =
    eventLiffId || search?.liffId || env.EVT_DEFAULT_LIFF_ID

  return {
    liffId: isLoading ? null : resolvedLiffId,
    isLoading: Boolean(eventId) && isLoading,
  }
}
